'use client'

import { useEffect, useState } from 'react'

export default function ShareLinkedIn({
  children,
  url,
  title,
  className,
}: {
  children?: React.ReactNode
  url?: string
  title?: string
  className?: string
}) {
  const [shareUrl, setShareUrl] = useState<string>(url || '')

  useEffect(() => {
    if (!shareUrl) {
      const currentUrl = window.location.href
      setShareUrl(currentUrl)
    }
  }, [shareUrl])

  return (
    <a
      href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title || '')}`}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
      aria-label='Share on LinkedIn'
    >
      {children}
    </a>
  )
}
